<template>
  <div class="contain">
    <div class="cont">
      <div v-for="l_name in list_show" :class="{active: com_list.length > 4, list_show}" :key="l_name">
        <div class="cus_table">
            <div class="c_tr">
              <div class="c_th"><div class="middle">公司名称</div></div>
              <div v-for="item in com_list" :key="item.uid" class="c_td">
                <div class="middle">
                  <div class="comp_info">
                      <div class="logo_img">
                        <img :src="item.logo_path | logo_show" alt="">
                      </div>
                      <div class="comp_name"><p>{{item.short_name}}</p></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="c_tr" v-for="(prop,index) in dynview_tag_type" :key="index">
              <div class="c_th"><div class="middle">{{prop.name}}</div></div>
              <div v-for="item in com_list" :key="item.uid" class="c_td">
                <div class="middle">
                  <div class="tags">
                    <span
                      class="span_tag"
                      v-for="item2 in item.tags"
                      v-if="type_bl(item2, prop.id)"
                      :key="item2">{{item2 | dealName(meta.dynview_tag)}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="c_tr">
                <div class="c_th"><div class="middle">成立时间</div></div>
                <div class="c_td" v-for="item in com_list" :key="item.uid"><div class="middle">{{item.setup_time | timeTrans}}</div></div>
            </div>
            <div class="c_tr">
                <div class="c_th"><div class="middle">地区</div></div>
                <div class="c_td" v-for="item in com_list" :key="item.uid"><div class="middle">{{item.province | pc(item.city)}}</div></div>
            </div>
            <div class="c_tr">
                <div class="c_th"><div class="middle">规模</div></div>
                <div class="c_td" v-for="item in com_list" :key="item.uid"><div class="middle">{{item.employee_id | dealName(meta.employee, 'id', 'employee')}}</div></div>
            </div>
            <div class="c_tr">
                <div class="c_th"><div class="middle">融资历程</div></div>
                <div class="c_td" v-for="item in com_list" :key="item.uid">
                  <div class="middle">
                    <ul class="rz_list" v-if="item.event.length > 0">
                        <li v-for="item2 in item.event">
                          <p class="p1">
                            <span class="sp1" v-if="item2.type == 1">并购：</span>
                            <span class="sp1" v-else>{{item2.round_id | dealName(meta.round)}}：</span>
                            <span class="sp2">{{item2.event_time | timeTrans}}</span>
                            <span class="sp3" v-if="item2.amount">{{item2.amount | amountPrecise(item2.unit_id, item2.precise, meta.unit)}}</span>
                          </p>
                          <p class="p2" v-if="item2.tzf">投资方：<span v-for="(prop,i) in item2.tzf" :key="i"><template v-if="i != 0">、</template>{{prop.entity_name}}</span></p>
                        </li>
                    </ul>
                    <template v-else>--</template>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <Spin fix v-if="loading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { entityCompare } from '@/service'
import { dynview_tag_mixins } from 'js/dynview_tag_mixins'
import filter from 'js/filter'
export default {
  name: 'AboutCompany',
  props: ['entityList','meta'],
  mixins: [dynview_tag_mixins],
  data() {
    return {
      com_list: [],
      loading: true,
      params: {
        uids: []
      },
      list_show: ['list_show','list_name'],
    }
  },
  computed: {
    dynview_tag_type() {
      return this.meta.dynview_tag_type
    },
    dynview_tag() {
      return this.meta.dynview_tag
    },
    uid_list() {
      let arr = []
      this.entityList.map((a) => {
        arr.push(a.uid)
      })
      return arr
    },
    type_bl() {
      return function (data_id, type_id) {
        let index = this.new_tags.findIndex((a) => {return a.id == data_id})
        if (index > -1) {
          if(this.new_tags[index].type_id == type_id){
            return true
          }else {
            return false
          }
        }
      }
    }
  },
  methods: {
    async getComList() {
      this.params.uids = this.uid_list
      let res = await entityCompare(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'com_list', res.res)
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    }
  },
  created() {
    this.getComList()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.contain
  position: relative
  commonBgColor(#1f2330, #FFFFFF)
  padding: 30px 50px
.cont
  position: relative
  commonColor(#e9e9eb, #333333)
  & > div:first-of-type
    width: 100%
    overflow: auto
  & > div:last-of-type
    position: absolute
    top: 0
    left: 0
    overflow: hidden
    width: 180px
    display: none
    box-shadow: 2px 0 6px 0 rgba(0,0,0,0.2)
    &.active
      display: block
.cus_table
  .c_tr
    display: flex
    position: relative
    .c_th
      display: flex
      flex: 0 0 179px
      border: 1px solid
      commonBorderColor(#40444f, #F3F3F3)
      border-right: 0
      border-top: 0
      commonColor(#bcbdc1, #666666)
      commonBgColor(#2a2f42, #FFFAF5)
      font-size: 14px
      justify-content:center
    .c_td
      display: flex
      font-size: 14px
      flex: 0 0 240px
      padding: 16px
      min-height: 50px
      border: 1px solid
      commonBorderColor(#40444f, #F3F3F3)
      border-right: 0
      border-top: 0
      .comp_info
        display: flex
        width: 199px
        .logo_img
          flex: 0 0 48px
          height: 48px
          line-height: 46px
        .comp_name
          flex: auto
          margin-left: 8px
          display: table
          height: 48px
          p
            font-size: 14px
            display: table-cell
            vertical-align: middle
      .rz_list
        li
          margin-top: 20px
          &:first-child
            margin-top: 0
          .p1
            .sp1
              color: rgba(250, 122, 80, 1)
            .sp3
              margin-left: 21px
              position: relative
              &:before
                content: ''
                position: absolute
                width: 1px
                height: 14px
                left: -11px
                top: 1px
                commonBgColor(#979797, #E8E8E8)
          .p2
            line-height: 20px
            margin: 7px 0 -3px
      .tags
        margin-bottom: -10px
        margin-right: -10px
        .span_tag
          padding: 6px 10px
          border-radius: 2px
          margin-right: 10px
          margin-bottom: 10px
          display: inline-block
          commonBgColor(#283545, #F5F5F5)
          commonColor(#949aa2, #666666)
    .c_td:last-of-type
      border-right: 1px solid
      commonBorderColor(#40444f, #F3F3F3)
    .middle
      align-self: center
    &:first-of-type
      .c_th
      .c_td
        border-top: 1px solid
        commonBorderColor(#40444f, #F3F3F3)
</style>
